import { encodeLoad, decodeLoad } from '@/lib/base64.js'
import {
  fetchWithTimeout,
  fetchErrorFields,
  FETCH_TIMEOUT_MS,
  FETCH_LONG_TIMEOUT_MS
} from '@/lib/fetchWithTimeout.js'

import dayjs from '@/plugins/dayjs.js'

// import { CreateHypatiaJWE } from '@/lib/createJWT'

// import { base64 } from 'base64-url'

// import { jwt } from 'jsonwebtoken'
// import * as jose from 'jose'

const ENGAGEURL = 'https://dsrl.eu:3081/engage-backend/'

/* The session id is carried on the x-memas-sid header (see server.js sidHeaderFallback);
   p1 in the request body is no longer used. The header is only set when a sid exists -
   otherwise the literal string 'null' would reach the server and all first-time clients
   would share the same session. */
const memasHeaders = (store, contentType) => {
  let headers = {
    Authorization: `Bearer ${store.serveraccesstoken}`,
    Accept: 'application/json',
    memasclient: 'betterhealthforall' // for Cloud armor firewall rules
  }
  if (contentType) headers['Content-Type'] = contentType
  let sid = store.sid || localStorage.getItem('sid')
  if (sid) headers['x-memas-sid'] = sid
  return headers
}

/* Reject with an Error carrying axios-compatible fields (.status, .data, .errorMsg) so
   the existing .catch() handlers and checkError(error) keep working. */
const httpError = (error, status, data) => {
  if (!(error instanceof Error)) error = new Error(String(error))
  error.success = false
  error.error = true
  Object.assign(error, fetchErrorFields(error))
  if (status !== undefined) error.status = status
  if (data !== undefined) error.data = data
  if (error.status !== undefined || error.data !== undefined) {
    error.response = { status: error.status, data: error.data }
  }
  return error
}

/* An empty or non-JSON body is not an error - axios returned it as ''/raw text. */
const readJsonBody = async (response) => {
  const text = await response.text()
  if (!text) return null
  try {
    return JSON.parse(text)
  } catch {
    return text
  }
}

export const adminActions = {
  setTest(text) {
    console.log('set TEST got called (%s)', text)
    this.test = text
  },
  setSelectedService(serviceid) {
    this.services.add(serviceid)
  },
  /* Should be the same i both adminweb and user*/
  isActiveService(serviceid) {
    return this.services.has(serviceid)
  },
  setActiveNavItem(navItem) {
    this.activenavitem = navItem
  },
  setUiLevel(level) {
    this.uilevel = level
  },
  setLang(lang) {
    this.lang = lang
  },
  setServername(server) {
    this.servername = server
  },
  setRegistryUrl(server) {
    this.registryurl = checkRegistryURL(server)
  },
  setServerUrl(server) {
    console.info('<<<<<<<<<<<<<<< SET SERVER URL >>>>>>>>>>>')
    console.info(server)
    this.serverurl = checkRegistryURL(server)
    console.info(this.serverurl)
  },
  setExpires(payload) {
    this.expires = payload
  },
  setEnvironment(environment) {
    this.environment = environment
  },
  setServerAccessToken(payload) {
    this.serveraccesstoken = payload
  },
  checkError(error) {
    console.info('CHECK ERROR (%s)', error.status)
    if (error.status > 400) {
      console.info('Error status > 400')
      console.info(error)
      /* useRouter() only works inside component setup - a Pinia action has no component
         context. The app router instance lives in src/router/index.js; a dynamic import
         is used here so this module does not create a circular import with the router
         (which imports userStore). */
      import('@/router/index.js').then(({ default: router }) => {
        // Don't redirect if we're on Microsoft callback - let it handle the error
        let currentRoute = router.currentRoute.value
        if (currentRoute.path && currentRoute.path.startsWith('/mscallback')) {
          console.log(
            'On Microsoft callback route, not redirecting to LandingPage'
          )
          return
        }

        localStorage.clear()
        router.push({ name: 'LandingPage' })
      })
    }
  },
  //  setDataFrominfoUrl(payload) {
  async setDatafrominfourl(payload) {
    console.log('fetchDataFrominfoUrl got called ')
    console.log(payload)
    //  console.log(JSON.stringify(payload))

    return new Promise((resolve) => {
      this.getHTTP('test/')
        .then((result) => {
          console.log('getDataFromInfoUrl returned')
          console.log(result.data)
          resolve({
            success: true,
            html: decodeLoad(result.data.dgraphresult.htmlData)
          })
        })
        .catch((error) => {
          console.log('COULD NOT GET URL DATA')
          this.checkError(error)
          resolve({
            success: false,
            error: true,
            errorMsg: JSON.stringify(error)
          })
        })
    }) // promise
  },
  async setSchema() {
    console.log('SET MEMAS Schema got called ! ')
    return new Promise((resolve, reject) => {
      // let serverUrl = this.serverurl
      // let accessClientToken = userStore.serveraccesstoken
      // let accessClientToken = context.getters.getIdToken
      // console.info('========= idToken !!: ' + accessClientToken)
      let pLoad = {
        gogl: true
      }
      console.log('PLOAD IS ', pLoad)
      // console.log('Accesstoken (%s)', userStore.serveraccesstoken)
      this.postHTTP('dgraphschema/setschema', pLoad)
        .then((res) => {
          console.log('RES FROM Set Schema', res)
          resolve({ success: true, data: res.data })
        })
        .catch((error) => {
          console.log('GET SERVER INSTANCE ERROR ')
          this.checkError(error)
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log('*** ERRRO ***')
            console.log(error.response.data)
            console.log(error.response.status)
            console.log(error.response.headers)
          } else if (error.request) {
            console.log('*** ERRRO REQUST ***')
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request)
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message)
          }
          console.log('*** ERROR *** CONFIG')
          console.log(error.config)
          reject({ success: false, error: error.message })
        })
      /*
      instance
        .post('', pLoad)
        .then((response) => {
          console.log('setSchema response: ')
          resolve(response)
        })
        .catch((error) => {
          console.error('updateSchema had an error: ', error)
          reject(new Error('updateSchema had an error: ', error))
        })
        */
    }) // promise
  },
  async setSchemaFOO() {
    console.log('SET MEMAS Schema Foo got called ! ')
    return new Promise((resolve, reject) => {
      // let serverUrl = this.serverurl
      // let accessClientToken = userStore.serveraccesstoken
      // let accessClientToken = context.getters.getIdToken
      // console.info('========= idToken !!: ' + accessClientToken)
      let pLoad = {
        gogl: true
      }
      console.log('PLOAD IS ', pLoad)
      this.getHTTP('foo')
        .then((res) => {
          console.log('RES FROM Set schema', res)
          resolve({ success: true, data: res.data })
        })
        .catch((error) => {
          console.log('GET SERVER INSTANCE ERROR ')
          this.checkError(error)
          if (error.response) {
            // The request was made and the server responded with a status code
            // that falls out of the range of 2xx
            console.log('*** ERRRO ***')
            console.log(error.response.data)
            console.log(error.response.status)
            console.log(error.response.headers)
          } else if (error.request) {
            console.log('*** ERRRO REQUST ***')
            // The request was made but no response was received
            // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
            // http.ClientRequest in node.js
            console.log(error.request)
          } else {
            // Something happened in setting up the request that triggered an Error
            console.log('Error', error.message)
          }
          console.log('*** ERROR *** CONFIG')
          console.log(error.config)
          resolve({ error: true, success: false, errorMsg: error.message })
        })
      /*
      instance
        .post('', pLoad)
        .then((response) => {
          console.log('setSchema response: ')
          resolve(response)
        })
        .catch((error) => {
          console.error('updateSchema had an error: ', error)
          reject(new Error('updateSchema had an error: ', error))
        })
        */
    }) // promise
  },
  async getPingServer() {
    console.log('GET PING SERVER (%s)', this.serverurl)
    return new Promise((resolve, reject) => {
      this.getHTTP('kubeheartbeat/isalive')
        .then((result) => {
          console.log('getPingServer er: (' + JSON.stringify(result) + ')')
          resolve(result.data)
        })
        .catch((error) => {
          console.error('*** ERROR *** getPingServer had some errors:', error)
          reject({
            errorMsg: '*** ERROR *** getPingServer had some errors:' + error
          })
        })
    }) // promise
  },
  async addRegistryUrl() {
    console.log('addRegistryUrl got called:(' + this.servername + ')')
    // let serverUrl = payload.serverURL
    return new Promise((resolve) => {
      // getURLHost(serverUrl)
      // console.log('============ got client Server ======== (' + serverUrl + ')')
      resolve({ success: true, serverurl: this.serverurl })
      /*
      this.getHTTPSimple(
        checkRegistryURL(this.servername) + 'lsregistry/index.json'
      )
        .then((result) => {
          console.log(
            'REGISTRY Server er: (' + JSON.stringify(result.data) + ')'
          )
          let registryUrl = ''
          if (result.data.registry_server_port === '') {
            registryUrl = result.data.registry_server
          } else {
            registryUrl =
              result.data.registry_server +
              ':' +
              result.data.registry_server_port
          }
          // context.commit('setServerUrl', payload)
          localStorage.setItem('memasregistry', checkRegistryURL(registryUrl))
          this.registryurl = checkRegistryURL(registryUrl)
          console.log(
            '>>> GETTING SERVER FROM REGISTRY (%sls/memasserver)',
            this.registryurl
          )
          this.getHTTPSimple(
            checkRegistryURL(this.registryurl) + 'ls/memasserver'
          )
            .then((result) => {
              console.log('setServerUrl/memasServer/get got:')
              console.log(result)
              // console.log(result.data)
              if (result.data.error !== undefined) {
                reject({
                  error: '*** ERROR *** no result from registry service.',
                  errormsg:
                    'The Learning Registry service need to be configured !'
                })
              }
              let serverURL = checkURL(result.data.hostname, result.data.port)
              // console.log('---- serverURL (' + serverURL + ')')
              localStorage.setItem('memasserver', serverURL)
              this.setServerUrl(serverURL)
              resolve({
                result: serverURL
              })
            })
            .catch((error) => {
              console.error(
                '*** ERROR *** addRegistryUrl/getting memas-server info (' +
                  error +
                  ')'
              )
              reject({
                error:
                  '*** ERROR *** addRegistryUrl/getting memas-server info :',
                errormsg: error
              })
            })
        })
        .catch((error) => {
          console.error(
            '*** ERROR *** addRegistryUrl getting registry service: '
          )
          console.error(error)
          reject({
            error: '*** ERROR *** addRegistryUrl/getting registry service: ',
            errormsg: error
          })
        })
          */
    }) // promise
    // context.commit('setServerUrl', payload.serverURL)
  },
  testPromise(payload) {
    console.log('testPromise got called ')
    console.log(payload)
    //  console.log(JSON.stringify(payload))
    return new Promise((resolve) => {
      resolve({
        success: false,
        error: true,
        message: 'hopp og hei'
      })
    }) // promise
  },
  async prepareEngageActivityData() {
    return {
      success: true,
      heartValues: new Map(),
      activityValues: new Map(),
      sleepValues: new Map()
    }
  },
  async prepareEngageActivityData_NU() {
    let { userStore } = await import('@/stores/userstore.js')
    let uStore = userStore()
    let primaryUser = uStore.primaryuser
    console.log('PRIMARY USER (%j)', primaryUser)
    this.primaryUserUID = primaryUser.pu_userid || '' // 'c0d76813-c0ab-4fdb-8613-770259d89209' // primaryUser.pu_userid
    let apiUrl = ENGAGEURL + 'fitbit/summary/'
    try {
      const res = await this.getHTTPSimple(
        checkRegistryURL(apiUrl) + this.primaryUserUID
      )
      console.log('getFitBitData Returned (%j)', res)
      let resData = res.data || {}
      console.log('res data')
      console.log(resData)
      let eData = resData
      let activityData = eData.activity || [{}]
      let heartData = eData.heart || [{}]
      let sleepData = eData.sleep || [{}]
      let activityMap = new Map()
      for (let i = 0; i < activityData.length; i++) {
        let activity = activityData[i]
        let activityDate = activity.date
        let activityLevel = {}
        activityLevel.sedate = activity.sedentaryMinutes
        activityLevel.lightly = activity.lightlyActivityMinutes
        activityLevel.fairly = activity.fairlyActivityMinutes
        activityLevel.very = activity.veryActivityMinutes
        activityMap.set(activityDate, activityLevel)
      }
      let heartMap = new Map()
      for (let i = 0; i < heartData.length; i++) {
        let heart = heartData[i] || {}
        //        console.log('HEARTH (%j)', heart)
        let hDate = heart.dateTime
        let heartHourValues = heart.general || []
        let heartHourMap = new Map()
        for (let j = 0; j < heartHourValues.length; j++) {
          let hourValue = heartHourValues[j]
          let zones = hourValue.zones || []
          for (let k = 0; k < zones.length; k++) {
            let zone = zones[k]
            let zoneName = zone.name
            if (heartHourMap.has(zoneName)) {
              let zoneMinutes = heartHourMap.get(zoneName)
              heartHourMap.set(zoneName, zoneMinutes + zone.minutes)
            } else {
              heartHourMap.set(zoneName, zone.minutes)
            }
            // heartHourMap.set(zoneName, zoneMinutes)
          }
          // console.log('HOUR VALUE (%j)', hourValue)
          //let hourDay = hourValue.hour
          // heartHourMap.set(hourDay,hourValue.zones)
        }
        heartMap.set(hDate, heartHourMap)
      }
      let sleepMap = new Map()
      for (let i = 0; i < sleepData.length; i++) {
        let sStages = {}
        let sleep = sleepData[i]
        let sleepDate = sleep.dateTime
        let sSummary = sleep.summary || []
        let sleepDetails = sSummary[0] || {}
        let sleepStages = sleepDetails.stages || []
        for (let j = 0; j < sleepStages.length; j++) {
          let sDetail = sleepStages[j]
          if (sDetail.name === 'deep') {
            sStages.deep = sDetail.value
          }
          if (sDetail.name === 'light') {
            sStages.light = sDetail.value
          }
          if (sDetail.name === 'rem') {
            sStages.rem = sDetail.value
          }
          if (sDetail.name === 'wake') {
            sStages.wake = sDetail.value
          }
        }
        sleepMap.set(sleepDate, sStages)
      }
      // this.timeRadarData = this.getChart2()
      return {
        success: true,
        heartValues: heartMap,
        activityValues: activityMap,
        sleepValues: sleepMap
      }
    } catch (err) {
      console.error('Error in getFitBitData: ', err)
      return {
        success: false,
        error: true,
        errorMsg: 'Error in getFitBitData: ' + err
      }
    }
  },
  async prepareMLData() {
    return {
      success: true,
      mlValues: new Map()
    }
  },
  async prepareMLData_NU() {
    const { userStore } = await import('@/stores/userstore.js')
    let uStore = userStore()
    let primaryUser = uStore.primaryuser
    console.log('PRIMARY USER (%j)', primaryUser)
    this.primaryUserUID = primaryUser.pu_userid || '' // 'c0d76813-c0ab-4fdb-8613-770259d89209' // primaryUser.pu_userid
    let apiUrl = ENGAGEURL + 'fitbit/prediction/daily-fragmentation/'
    // let apiUrl = ENGAGEURL + 'fitbit/prediction/'
    // this.primaryUserUID = 'c211ad68-c30e-40a9-88d9-07465f6cff86'
    try {
      const res = await this.getHTTPSimple(
        checkRegistryURL(apiUrl) + this.primaryUserUID
      )
      console.log('get ML Data Returned (%j)', res)
      let resData = res.data || {}
      console.log('res data')
      console.log(resData)
      let mlMap = new Map()

      for (let i = 0; i < resData.length; i++) {
        let ml = resData[i]
        let mlDate = dayjs(ml.startDateTime).format('ddd DD MMM')
        console.log('mlData (%s)', mlDate)
        let mlLevel = {}
        switch (ml.category) {
          case 'Low':
            mlLevel.low = ml.fragmentationIndex
            break
          case 'High':
            mlLevel.high = ml.fragmentationIndex
            break
          case 'Very High':
            mlLevel.veryhigh = ml.fragmentationIndex
            break
          default:
            mlLevel.medium = ml.fragmentationIndex
        }
        mlMap.set(mlDate, mlLevel)
        /*{
          level: mlLevel,
          fragementation: mlFragmentation
        })*/
      }

      // this.timeRadarData = this.getChart2()
      return {
        success: true,
        mlValues: mlMap
      }
    } catch (err) {
      console.error('Error in getFitBitData: ', err)
      return {
        success: false,
        error: true,
        errorMsg: 'Error in getFitBitData: ' + err
      }
    }
  },
  /* Fetch-based HTTP helpers - all server communication goes through these.
     Failures reject (same contract axios had) so callers' .catch() handlers run. */
  async postHTTP(path, loadData) {
    let url = this.serverurl
    if (!url) {
      throw httpError('no serverUrlSet')
    }
    console.log('postHTTP url(' + checkRegistryURL(url) + path + ')')
    try {
      const response = await fetchWithTimeout(
        checkRegistryURL(url) + path,
        {
          method: 'POST',
          mode: 'cors',
          credentials: 'include',
          body: JSON.stringify(loadData),
          headers: memasHeaders(this, 'application/json')
        },
        FETCH_TIMEOUT_MS
      )
      const data = await readJsonBody(response)
      if (!response.ok) {
        throw httpError(
          new Error(`HTTP error! status: ${response.status}`),
          response.status,
          data
        )
      }
      return {
        success: true,
        error: false,
        data: data,
        ok: response.ok,
        status: response.status
      }
    } catch (error) {
      console.error('*** ERROR *** postHTTP', { errorMsg: error.toString() })
      throw httpError(error, error.status, error.data)
    }
  },
  async getHTTP(path) {
    let url = this.serverurl
    if (!url) {
      throw httpError('no serverUrlSet')
    }
    console.log('getHTTP url(' + checkRegistryURL(url) + path + ')')
    try {
      const response = await fetchWithTimeout(
        checkRegistryURL(url) + path,
        {
          method: 'GET',
          mode: 'cors',
          /* MUST be 'include'. This is the call that fetches sysinfo/jwtsecret, and without it the
             browser discards the Set-Cookie on the login response entirely - every later request
             then reaches the server with no session and req.session.secretuuid is undefined. */
          credentials: 'include',
          headers: memasHeaders(this, 'application/json')
        },
        FETCH_TIMEOUT_MS
      )
      const data = await readJsonBody(response)
      if (!response.ok) {
        throw httpError(
          new Error(`HTTP error! status: ${response.status}`),
          response.status,
          data
        )
      }
      return {
        success: true,
        error: false,
        data: data,
        ok: response.ok,
        status: response.status
      }
    } catch (error) {
      console.error('*** ERROR *** getHTTP', { errorMsg: error.toString() })
      throw httpError(error, error.status, error.data)
    }
  },
  async getHTTPSimple(url) {
    /* Plain GET against a full URL - no auth headers. Used for the registry service
       and external APIs that do not need a session. */
    console.log('getHTTPSimple url(' + url + ')')
    try {
      const response = await fetchWithTimeout(url, {}, FETCH_TIMEOUT_MS)
      const data = await readJsonBody(response)
      if (!response.ok) {
        throw httpError(
          new Error(`HTTP error! status: ${response.status}`),
          response.status,
          data
        )
      }
      return {
        success: true,
        error: false,
        data: data,
        ok: response.ok,
        status: response.status
      }
    } catch (error) {
      console.error('*** ERROR *** getHTTPSimple', {
        errorMsg: error.toString()
      })
      throw httpError(error, error.status, error.data)
    }
  },
  async postHTTPForm(path, formData) {
    /* Multipart upload - the browser sets the multipart boundary itself, so
       Content-Type must NOT be set here. */
    let url = this.serverurl
    if (!url) {
      throw httpError('no serverUrlSet')
    }
    console.log('postHTTPForm url(' + checkRegistryURL(url) + path + ')')
    try {
      const response = await fetchWithTimeout(
        checkRegistryURL(url) + path,
        {
          method: 'POST',
          mode: 'cors',
          credentials: 'include',
          body: formData,
          headers: memasHeaders(this)
        },
        FETCH_LONG_TIMEOUT_MS
      )
      const data = await readJsonBody(response)
      if (!response.ok) {
        throw httpError(
          new Error(`HTTP error! status: ${response.status}`),
          response.status,
          data
        )
      }
      return {
        success: true,
        error: false,
        data: data,
        ok: response.ok,
        status: response.status
      }
    } catch (error) {
      console.error('*** ERROR *** postHTTPForm', {
        errorMsg: error.toString()
      })
      throw httpError(error, error.status, error.data)
    }
  },
  async postHTTPAudio(path, loadData) {
    /* POST returning binary audio (TTS). fetchWithTimeout reads the body as text,
       which would corrupt binary data, so this one keeps its own AbortController. */
    let url = this.serverurl || localStorage.getItem('hypsaserver')
    if (!url) {
      throw httpError('no serverUrlSet')
    }
    console.log('postHTTPAudio url(' + checkRegistryURL(url) + path + ')')
    const controller = new AbortController()
    const timer = setTimeout(() => controller.abort(), FETCH_LONG_TIMEOUT_MS)
    try {
      const response = await fetch(checkRegistryURL(url) + path, {
        method: 'POST',
        mode: 'cors',
        credentials: 'include',
        signal: controller.signal,
        body: JSON.stringify(loadData),
        headers: memasHeaders(this, 'application/json')
      })
      if (!response.ok) {
        throw httpError(
          new Error(`HTTP error! status: ${response.status}`),
          response.status
        )
      }
      const data = await response.arrayBuffer()
      return {
        success: true,
        error: false,
        data: data,
        ok: response.ok,
        status: response.status
      }
    } catch (error) {
      console.error('*** ERROR *** postHTTPAudio', {
        errorMsg: error.toString()
      })
      throw httpError(error, error.status, error.data)
    } finally {
      clearTimeout(timer)
    }
  },
  getDiagnosis(lang) {
    /*Heart failure (oversatt fra norsk)
    Heart failure (Romania)
    COPD
    Diabetes
    Heart attack
    Aorta stenosis (Romania)
  */
    console.log('GET DIAGNOSIS (%s)', lang)
    console.log(lang)
    switch (lang) {
      case 'en':
        return [
          {
            label: 'heartfailure',
            value: 'diagnosis.heartfailure', // is mapped $t('services.today')
            tooltip: 'diagnosis.heartfailuretooltip',
            default: false
          }
        ]
      case 'fr':
        return [
          {
            label: 'heartfailure',
            value: 'diagnosis.heartfailure', // is mapped $t('services.today')
            tooltip: 'diagnosis.heartfailuretooltip',
            default: false
          }
        ]
      case 'it':
        return [
          {
            label: 'infection',
            value: 'diagnosis.infection', // is mapped $t('services.today')
            tooltip: 'diagnosis.infectiontooltip',
            default: false
          }
        ]
      case 'ro':
        return [
          {
            label: 'heartfailure',
            value: 'diagnosis.heartfailure', // is mapped $t('services.today')
            tooltip: 'diagnosis.heartfailuretooltip',
            default: false
          },
          {
            label: 'aortastenosis',
            value: 'diagnosis.aortastenosis', // is mapped $t('services.today')
            tooltip: 'diagnosis.aortastenosistooltip',
            default: false
          }
        ]
      case 'nb':
      default:
        return [
          {
            label: 'heartfailure',
            value: 'diagnosis.heartfailure', // is mapped $t('services.today')
            tooltip: 'diagnosis.heartfailuretooltip',
            default: true
          },
          {
            label: 'heartattack',
            value: 'diagnosis.heartattack',
            tooltip: 'diagnosis.heartattacktooltip',
            default: false
          },
          {
            label: 'copd', // kols
            value: 'diagnosis.copd',
            tooltip: 'diagnosis.copdtooltip',
            default: false
          },
          {
            label: 'diabetes1',
            value: 'diagnosis.diabetes1',
            tooltip: 'diagnosis.diabetes1tooltip',
            default: false
          },
          {
            label: 'diabetes2',
            value: 'diagnosis.diabetes2',
            tooltip: 'diagnosis.diabetes2tooltip',
            default: false
          },
          {
            label: 'aortastenosis',
            value: 'diagnosis.aortastenosis',
            tooltip: 'diagnosis.aortastenosistooltip',
            default: false
          },
          {
            label: 'obesity',
            value: 'diagnosis.obesity',
            tooltip: 'diagnosis.obesitytooltip',
            default: false
          },
          {
            label: 'blodpressure',
            value: 'diagnosis.blodpressure',
            tooltip: 'diagnosis.blodpressuretooltip',
            default: false
          },
          {
            label: 'cognitiveloss',
            value: 'diagnosis.cognitiveloss',
            tooltip: 'diagnosis.cognitivelosstooltip',
            default: false
          },
          {
            label: 'infection',
            value: 'diagnosis.infection',
            tooltip: 'diagnosis.infectiontooltip',
            default: false
          }
        ]
    } // switch
  }
}

function checkRegistryURL(url) {
  if (url.length > 0) {
    let lastChar = url.charAt(url.length - 1)
    // console.log('CHECK REGISTRY URL (%o) lastchar(%o)', url, lastChar)
    if (lastChar === '/') {
      return url
    } else {
      return url + '/'
    }
  } else {
    console.error('NO URL PROVIDED !!! ')
    return ''
  }
}

function checkURL(url, port) {
  console.log('checkURL : (' + url + ') (' + port + ')')
  let newUrl = ''
  if (!url) {
    return ''
  }
  if (port === null || port === undefined) {
    port = ''
  }
  if (url.slice(0, 5) === 'https' && port === '') {
    newUrl = url
  } else if (url.slice(0, 5) === 'https' && port !== '') {
    newUrl = url + ':' + port
  } else if (url.slice(0, 4) === 'http' && port === '') {
    newUrl = url
  } else if (url.slice(0, 4) === 'http' && port !== '') {
    newUrl = url + ':' + port
  } else if (port === '443') {
    newUrl = 'https://' + url
  } else if (port !== '') {
    newUrl = 'http://' + url + ':' + port
  } else {
    newUrl = 'http://' + url
  }
  return newUrl
}
